export default "__VITE_ASSET__BUEVO3nA__"